<ng-container *ngIf="subscription_id">
  <div class="app-container">
    <app-chat-thread-new [subscription_id]="subscription_id">
    </app-chat-thread-new>
  </div>
</ng-container>
<ng-container *ngIf="!subscription_id">
  <div class="app-container-else-wrapper">
    <div class="app-container-else">
      <ng-container *ngIf="environment.products['postgenie']">
        <div class="col-lg text-center pb-3">
          <img src="/assets/img/hands.png" />
          <h4>
            Welcome to <strong>PostGenie</strong>
            {{ user()?.displayName?.split(",")[1] }}!
          </h4>
          Your personal <strong>LinkedIn post assistant</strong> that works to
          <br />
          enhance creativity and brand conformance. <br />
          Please select a valid subscription to continue:
        </div>
      </ng-container>

      <ng-container *ngIf="!environment.products">
        <h3>Please select a valid subscription to continue</h3>
      </ng-container>

      <mat-form-field appearance="fill">
        <mat-label>Subscription</mat-label>
        <mat-select (selectionChange)="setSubscription($event.value)">
          <mat-option
            *ngFor="let subscription of subscriptions"
            [value]="subscription.subscription_id"
          >
            {{ subscription.service_nickname }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</ng-container>
